import { lazyOnSupportPaneClose, lazyRenderFeedbackPane, lazyRenderGetDiagnosticsPane, lazyRenderSupportPane } from "diagnostics-and-support";
import { GetUrlToOpenUsingDefault } from "flora-common";
import { ActivityFeed, ActivityFeedTitle, lazyToggleActivityFeed } from "owa-activity-feed";
import { logUsage } from "owa-analytics";
import classNames from "owa-classnames";
import { ChatCopilotPane, ChatCopilotPaneHeader } from "owa-copilot-chat";
import { DictationHelpPane } from "owa-editor-dictation";
import { DexPaneWrapper, lazyCloseDexPane } from "owa-editor-proofing-dex-pane";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { GroupsPanelContainer, GroupsPanelHeader } from "owa-groups-panel-container";
import { incrementSidepaneClickCountAction } from "owa-groups-panel-feedback";
import { RolloutOverridesPane } from "owa-header-pane";
import { content } from "owa-header-pane/lib/components/HeaderPane.scss";
import { deactivateCharm, getActiveCharm, type HeaderCharmType, toggleCharm } from "owa-header-store";
import loc from "owa-localize";
import { activityFeedTitle } from "owa-locstrings/lib/strings/activityfeedtitle.locstring.json";
import { feedbackCharm_ariaLabel } from "owa-locstrings/lib/strings/feedbackcharm_arialabel.locstring.json";
import { noteFeedFlexPaneTitle } from "owa-locstrings/lib/strings/notefeedflexpanetitle.locstring.json";
import { tips_FlexPane_Title } from "owa-locstrings/lib/strings/tips_flexpane_title.locstring.json";
import { whatsNew_FlexPane_Title } from "owa-locstrings/lib/strings/whatsnew_flexpane_title.locstring.json";
import { NotesPane } from "owa-notes-components";
import { popoutMailReadingPane } from "owa-popout";
import { launchCalendarReadingPane } from "owa-calendar-forms-launch-handlers";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Avoid deprecated APIs, use portals instead of rendering to a new root
 *	> 'render' import from 'owa-react-dom' is restricted. Use react portals instead of rendering into a new root */
import { render } from "owa-react-dom";
import { KnownIssuesFeedbackForm, KnownIssuesFeedbackFormHeader } from "owa-smiley-feedback";
import { closeFlexPane } from "owa-suite-header-apis";
import { TimePanel, TimePanelHeaderBar } from "owa-time-panel/lib/lazyCalendarBoot";
import { onBundleLoadTimeStart } from "owa-time-panel-datapoints/lib/utils/bundleLoadTimeUtils";
import { WhatsNewFluentPane } from "owa-whats-new";
import React from "react";
import { focusAsync } from "@fluentui/utilities";
import { AddinsFlexPaneBody, AddinsFlexPaneHeader } from "owa-addins-view";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { OwaActivityFeedButtonID, OwaActivityFeedFlexPaneID, OwaChatCopilotFlexPaneID, OwaDexFlexPaneId, OwaDiagFeedbackButtonID, OwaDiagFeedbackFlexPaneID, OwaDiagnosticsButtonID, OwaDiagnosticsFlexPaneID, OwaDictationHelpFlexPaneID, OwaFeedbackButtonID, OwaFeedbackFlexPaneID, OwaGroupsPanelFlexPaneID, OwaNoteFeedButtonID, OwaNoteFeedFlexPaneID, OwaRolloutOverridesButtonID, OwaRolloutOverridesFlexPaneID, OwaSkypeFlexPaneID, OwaSupportButtonID, OwaSupportFlexPaneID, OwaGetDiagnosticsButtonID, OwaGetDiagnosticsFlexPaneID, OwaTimePanelButtonID, OwaTimePanelFlexPaneID, OwaTipsButtonID, OwaTipsFlexPaneID, OwaWhatsNewButtonID, OwaWhatsNewFlexPaneID, OwaAddinsFlexPaneID, } from "../constants";
import { groupsPanelHeaderText, timePanelHeaderText } from "../strings.locstring.json";
import createShellFlexPane from "../utils/createShellFlexPane";
import renderInsideFlexPane from "../utils/renderInsideFlexPane";
import { prefetchTimePanelResources } from "owa-time-panel/lib/utils/prefetchTimePanelResources";
import { dexLitePaneHeaderShellPane, dictationHelpHeaderText, } from "./OwaSuiteFlexPane.locstring.json";
import { customFlexPane, fullHeightFlexPane, groupsPanelContainer, timePanelContainer, addinsPane, } from "./OwaSuiteHeader.scss";
import type { CustomShellFlexPane, ShellFlexPane } from "@1js/suiteux-shell-react";
import type { HeaderPaneProps } from "owa-bootstrap";
import type { MailboxInfo } from "owa-client-types";
import { ConvertIdSource, translateRestIdsToRestImmutableIds } from "owa-immutable-id";
import { isImmutableId } from "owa-immutable-id-store";
import { convertRestIdToEwsId } from "owa-identifiers";
import type { ReadingPaneEntrySourceType } from "owa-calendar-helpers-types/lib/ReadingPaneEntrySourceType";
import { tryGetGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
const FLEX_PANE_CLOSE_BUTTON_ID = "flexPaneCloseButton";
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaDiagFeedbackFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaDiagFeedbackFlexPaneID,
    flexPaneTitle: () => "",
    triggerControlID: OwaDiagFeedbackButtonID,
    containerClassName: customFlexPane,
    render: (container: HTMLDivElement) => {
        lazyRenderFeedbackPane.importAndExecute(container, () => {
            closeFlexPane(OwaDiagFeedbackFlexPaneID);
        });
    },
} as ShellFlexPane);
function closeOwaFeedbackFlexPane() {
    closeFlexPane(OwaFeedbackFlexPaneID);
}
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaFeedbackFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaFeedbackFlexPaneID,
    flexPaneTitle: () => loc(feedbackCharm_ariaLabel),
    customTitle: (container: HTMLDivElement) => {
        legacyRender(<KnownIssuesFeedbackFormHeader />, container);
    },
    triggerControlID: OwaFeedbackButtonID,
    containerClassName: customFlexPane,
    render: (container: HTMLDivElement) => {
        legacyRender(<KnownIssuesFeedbackForm onSendFeedback={closeOwaFeedbackFlexPane}/>, container);
    },
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaRolloutOverridesFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaRolloutOverridesFlexPaneID,
    flexPaneTitle: () => "Rollout Overrides", // No need to localize as it is a DEV feature only
    triggerControlID: OwaRolloutOverridesButtonID,
    containerClassName: customFlexPane,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<RolloutOverridesPane />, "Rollout Overrides", content),
    onFlexPaneOpen: () => focusAsync(document.getElementById(FLEX_PANE_CLOSE_BUTTON_ID)),
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaTimePanelFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaTimePanelFlexPaneID,
    flexPaneTitle: () => loc(timePanelHeaderText),
    triggerControlID: OwaTimePanelButtonID,
    containerClassName: classNames(timePanelContainer, customFlexPane),
    customTitle: (container: HTMLDivElement) => {
        legacyRender(<TimePanelHeaderBar onClosePanel={onTimePanelDismiss}/>, container);
    },
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<TimePanel onClosePanel={onTimePanelDismiss}/>, 
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    loc(timePanelHeaderText), undefined /* className */, undefined /* callback */, true /* forceLegacy - temporary mitigation for bug - 329525 */),
    onFlexPaneOpen: () => {
        onBundleLoadTimeStart(Date.now());
        prefetchTimePanelResources();
    },
    customEscapeKeyHandling: true,
} as ShellFlexPane);
export function getOwaChatCopilotFlexPane(containerClassName: string, customTitleClassName: string | undefined): ShellFlexPane {
    return createShellFlexPane({
        flexPaneID: OwaChatCopilotFlexPaneID,
        containerClassName,
        customTitleClassName,
        customTitle: (container: HTMLDivElement) => legacyRender(<ChatCopilotPaneHeader />, container),
        render: (container: HTMLDivElement) => legacyRender(<ChatCopilotPane isVisible={true}/>, container),
        customEscapeKeyHandling: true,
    } as ShellFlexPane);
}
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaAddinsFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaAddinsFlexPaneID,
    onFlexPaneClose: () => {
        const closeButton = document.getElementById(FLEX_PANE_CLOSE_BUTTON_ID);
        if (closeButton) {
            closeButton.style.display = "block";
        }
    },
    containerClassName: addinsPane,
    render: (container: HTMLDivElement) => {
        legacyRender(<AddinsFlexPaneBody mailboxInfo={getModuleContextMailboxInfo()}/>, container);
        const closeButton = document.getElementById(FLEX_PANE_CLOSE_BUTTON_ID);
        if (closeButton) {
            closeButton.style.display = "none";
        }
    },
    customEscapeKeyHandling: true,
    customTitle: (container: HTMLDivElement) => {
        container.style.padding = "0px";
        container.style.width = "100%";
        legacyRender(<AddinsFlexPaneHeader mailboxInfo={getModuleContextMailboxInfo()} renderTaskPaneInPanel={true}/>, container);
    },
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaGroupsPanelFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaGroupsPanelFlexPaneID,
    flexPaneTitle: () => loc(groupsPanelHeaderText),
    containerClassName: classNames(groupsPanelContainer, customFlexPane),
    onFlexPaneOpen: () => {
        incrementSidepaneClickCountAction();
        logUsage("GroupsPanelFlexPaneOpened", tryGetGlobalSettingsAccountMailboxInfo());
    },
    onFlexPaneClose: () => {
        logUsage("GroupsPanelFlexPaneClosed", tryGetGlobalSettingsAccountMailboxInfo());
    },
    customTitle: (container: HTMLDivElement) => {
        legacyRender(<GroupsPanelHeader />, container);
    },
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<GroupsPanelContainer />, loc(groupsPanelHeaderText)),
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaWhatsNewFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaWhatsNewFlexPaneID,
    flexPaneTitle: () => loc(whatsNew_FlexPane_Title),
    triggerControlID: OwaWhatsNewButtonID,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<WhatsNewFluentPane />, loc(whatsNew_FlexPane_Title)),
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaTipsFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaTipsFlexPaneID,
    flexPaneTitle: () => loc(tips_FlexPane_Title),
    triggerControlID: OwaTipsButtonID,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<WhatsNewFluentPane />, loc(tips_FlexPane_Title)),
    onFlexPaneOpen: () => {
        setTimeout(() => {
            document.getElementById("O365fp_lastFocusable")?.focus();
        }, 500);
    },
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaSupportFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaSupportFlexPaneID,
    flexPaneTitle: () => "",
    triggerControlID: OwaSupportButtonID,
    containerClassName: customFlexPane,
    render: (container: HTMLDivElement) => {
        lazyRenderSupportPane.importAndExecute(container, () => {
            closeFlexPane(OwaSupportFlexPaneID);
        });
    },
    onFlexPaneClose: () => {
        lazyOnSupportPaneClose.importAndExecute();
    },
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaGetDiagnosticsFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaGetDiagnosticsFlexPaneID,
    flexPaneTitle: () => "",
    triggerControlID: OwaGetDiagnosticsButtonID,
    containerClassName: customFlexPane,
    render: (container: HTMLDivElement) => {
        lazyRenderGetDiagnosticsPane.importAndExecute(container, () => {
            closeFlexPane(OwaGetDiagnosticsFlexPaneID);
        });
    },
} as ShellFlexPane);
function onDismissDiagnosticPanel() {
    closeFlexPane(OwaDiagnosticsFlexPaneID);
}
export function OwaDiagnosticsFlexPane(DiagnosticsPanelType: React.ComponentType<HeaderPaneProps> | undefined): CustomShellFlexPane {
    return createShellFlexPane({
        flexPaneID: OwaDiagnosticsFlexPaneID,
        flexPaneTitle: () => "Diagnostics",
        triggerControlID: OwaDiagnosticsButtonID,
        containerClassName: fullHeightFlexPane,
        render: renderInsideFlexPane(DiagnosticsPanelType ? (<DiagnosticsPanelType onDismiss={onDismissDiagnosticPanel}/>) : (<div />), "Diagnostics"),
    } as ShellFlexPane);
}
const activityFeedOpenMailAction = {
    openMail: (mailboxInfo: MailboxInfo, messageId: string, itemId?: string) => {
        popoutMailReadingPane(
        /* itemId */ itemId, 
        /* conversationId */ undefined, 
        /* internetMessageId */ messageId, 
        /* mailboxInfo */ mailboxInfo);
    },
};
const activityFeedOpenCalendarAction = {
    openCalendar: (mailboxInfo: MailboxInfo, itemId: string) => {
        if (isImmutableId(itemId)) {
            const ewsImmutableId = convertRestIdToEwsId(itemId);
            launchCalendarReadingPane({
                itemId: { Id: ewsImmutableId, mailboxInfo },
                entrySource: "ActivityFeed" as ReadingPaneEntrySourceType,
            });
        }
        else {
            // The itemId needs to be converted to the immutable id before opening the calendar form.
            translateRestIdsToRestImmutableIds([itemId], ConvertIdSource.ActivityFeed).then(response => {
                const id = response[0];
                if (id) {
                    launchCalendarReadingPane({
                        itemId: { Id: id, mailboxInfo },
                        entrySource: "ActivityFeed" as ReadingPaneEntrySourceType,
                    });
                }
            });
        }
    },
};
const activityFeedOpenLinkAction = {
    openLink: (mailboxInfo: MailboxInfo, url: string) => {
        if (isAccountFeatureEnabled("doc-flora-stage1", mailboxInfo)) {
            openLinkWithFLORA(url, mailboxInfo);
        }
        else {
            window.open(url, "_blank");
        }
    },
};
async function openLinkWithFLORA(url: string, mailboxInfo: MailboxInfo): Promise<void> {
    const urlToOpen: string | undefined = await GetUrlToOpenUsingDefault(url, mailboxInfo);
    if (urlToOpen) {
        // OW: 270495 Need to use the main window instead of targetWindow to prevent a dialog from showing in popout's.
        const handle = window.open(urlToOpen, "_self");
        if (!handle) {
            logUsage("CnexErrorFLORAFailedToOpen", mailboxInfo);
        }
    }
    else {
        window.open(url, "_blank");
    }
}
function ActivityFeedFlexPanel() {
    return (<ActivityFeed openMailAction={activityFeedOpenMailAction} openLinkAction={activityFeedOpenLinkAction} openCalendarAction={activityFeedOpenCalendarAction}/>);
}
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaActivityFeedFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaActivityFeedFlexPaneID,
    flexPaneTitle: () => loc(activityFeedTitle),
    triggerControlID: OwaActivityFeedButtonID,
    containerClassName: fullHeightFlexPane,
    onFlexPaneOpen: () => {
        logUsage("ActivityFeed_CharmClicked", tryGetGlobalSettingsAccountMailboxInfo());
    },
    onFlexPaneClose: () => {
        // The useEffect cleanup function in ActivityFeed does not run when the pane is closed,
        // so manually setting this to update the store and note that the pane is closed.
        lazyToggleActivityFeed.importAndExecute(false /* isActivityFeedOpen */);
    },
    customTitle: (container: HTMLDivElement) => {
        legacyRender(<ActivityFeedTitle />, container);
    },
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<ActivityFeedFlexPanel />, loc(activityFeedTitle)),
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaNoteFeedFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaNoteFeedFlexPaneID,
    flexPaneTitle: () => loc(noteFeedFlexPaneTitle),
    triggerControlID: OwaNoteFeedButtonID,
    containerClassName: fullHeightFlexPane,
    onFlexPaneOpen: () => {
        if (window.performance) {
            window.performance.mark("StartStickyNotesSDKLoad");
        }
        logUsage(
        /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
         *	> Invalid Outlook telemetry EventName "oneNoteFeedCharmClicked": must start with a capital letter (A–Z). */
        "oneNoteFeedCharmClicked", tryGetGlobalSettingsAccountMailboxInfo());
    },
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<NotesPane scenario="NotesFeedFlexPane" onClosePanel={onNotesPanelDismiss}/>, 
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    loc(noteFeedFlexPaneTitle)),
    customEscapeKeyHandling: true,
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaDexFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaDexFlexPaneId,
    flexPaneTitle: () => loc(dexLitePaneHeaderShellPane),
    onFlexPaneClose: () => lazyCloseDexPane.importAndExecute(),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<DexPaneWrapper />, loc(dexLitePaneHeaderShellPane)),
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaSkypeFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaSkypeFlexPaneID,
    flexPaneTitle: () => null,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== 0) {
            toggleCharm(0);
        }
    },
    onFlexPaneClose: () => {
        deactivateCharm(0);
    },
    render: () => {
        // Intended to be empty, skype pane will be rendered separately
    },
} as ShellFlexPane);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createShellFlexPane called at module scope is not allowed. This may cause unwanted side effects. */
export const OwaDictationHelpFlexPane: CustomShellFlexPane = createShellFlexPane({
    flexPaneID: OwaDictationHelpFlexPaneID,
    flexPaneTitle: () => loc(dictationHelpHeaderText),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function renderInsideFlexPane called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function loc called at module scope is not allowed. This may cause unwanted side effects. */
    render: renderInsideFlexPane(<DictationHelpPane />, loc(dictationHelpHeaderText), content),
} as ShellFlexPane);
function onTimePanelDismiss() {
    closeFlexPane(OwaTimePanelFlexPaneID);
    // normally suite header would handle this concern, but Time Panel needs custom ESC key handling
    // so we need to manually setting focus back on the panel button per A11Y best practices
    document.getElementById(OwaTimePanelButtonID)?.focus();
}
function onNotesPanelDismiss() {
    closeFlexPane(OwaNoteFeedFlexPaneID);
    document.getElementById(OwaNoteFeedButtonID)?.focus();
}
// Temporary mitigation for bug #312848: the suite FlexPane assumes that its contents will be rendered in the legacy
// mode and won't unmount correctly if we use `createRoot`.  This hack should be removed once the FlexPane is fixed or
// replaced (bug #352426).
function legacyRender(element: React.ReactNode, container: Element) {
    render(element, container, undefined /* callback */, true /* forceLegacy */);
}
